module.exports = __webpack_public_path__ + "static/media/SandBalls2.6fe3f8c2.jpg";